import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTypeArchivingFailedAction = {
	type: 'DOCUMENT_TYPE_ARCHIVING_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTypeArchivingFailedAction => ({
	type: 'DOCUMENT_TYPE_ARCHIVING_FAILED',
	payload,
});
